// lib/woocommerceCatalog.ts
export type WooProduct = {
    id: string;
    name: string;
    slug: string;
    sku: string;
    price: string;
    stock_status: string;
    stock_quantity: number;
    custom_sale_price: number | null;
    has_custom_discount: boolean;
    images: {
        src: string;
        alt: string;
    }[];
    yith_product_brand?: Array<{
        id: number;
        name: string;
        slug: string;
    }> | null;
    brands?: any;
};

export type WooProductsResponse = {
    products: WooProduct[];
    total: number;
    totalPages: number;
};

export async function fetchWooProducts(page: number = 1, perPage: number = 20): Promise<WooProductsResponse> {
    try {
        const baseUrl = 'https://retail.vitaline.uz';
        const url = new URL(`${baseUrl}/wp-json/vitaline/v1/products`);

        url.searchParams.append('per_page', perPage.toString());
        url.searchParams.append('page', page.toString());
        url.searchParams.append('orderby', 'stock_quantity');
        url.searchParams.append('order', 'desc');

        const response = await fetch(url.toString(), {
            next: { revalidate: 1800 },
        });

        if (!response.ok) {
            throw new Error(`Custom API error: ${response.statusText}`);
        }

        const products: WooProduct[] = await response.json();
        const total = parseInt(response.headers.get('X-WP-Total') || '0');
        const totalPages = parseInt(response.headers.get('X-WP-TotalPages') || '0');

        return {
            products,
            total,
            totalPages,
        };
    } catch (error) {
        console.error('Error fetching custom products:', error);
        throw error;
    }
}

const encodeProductId = (id: string | number): string => {
    return Buffer.from(`post:${id}`).toString('base64');
};

export function convertWooProduct(product: WooProduct) {
    const encodedId = encodeProductId(product.id);
    const brandsArray = Array.isArray(product.brands) ? product.brands : [];

    return {
        id: encodedId,
        name: product.name,
        slug: product.slug,
        sku: product.sku || '', // Добавляем SKU
        image: {
            sourceUrl: product.images[0]?.src || '/images/products/default.jpg',
            altText: product.images[0]?.alt || product.name,
        },
        price: product.price,
        convertedPrice: product.price,
        stockStatus: product.stock_status === 'instock' ? 'IN_STOCK' : 'OUT_OF_STOCK',
        stockQuantity: product.stock_quantity,
        brands: {
            nodes: brandsArray.map(brand => ({
                id: brand.id.toString(),
                name: brand.name,
                slug: brand.slug,
            }))
        },
        customSalePrice: product.custom_sale_price || null,
        hasCustomDiscount: product.has_custom_discount || false,
    };
}